export default "__VITE_ASSET__CMutP2qI__"